var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",class:[
    _vm.size,
    { 'line-height': _vm.lineHeight, uppercase: _vm.uppercase, bold: _vm.bold },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }